var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return !_setup.hideWrapper
    ? _c(_setup.BaseLayersTreeItem, { attrs: { item: _vm.item } }, [
        _c("div", { staticClass: "layer-row pl-2" }, [
          _c("div", { staticClass: "grow-1 d-flex items-center" }, [
            _c(
              "div",
              {
                staticClass: "action cursor-pointer no-drag",
                on: {
                  "!click": function ($event) {
                    $event.preventDefault()
                    return _setup.onCollapseClick()
                  },
                },
              },
              [
                _vm.collapsed
                  ? _c("font-awesome-icon", {
                      staticClass: "mr-1 action-icon",
                      attrs: { icon: ["fas", "chevron-right"] },
                    })
                  : _c("font-awesome-icon", {
                      staticClass: "mr-1 action-icon",
                      attrs: { icon: ["fas", "chevron-down"] },
                    }),
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "icon element-icon mr-2" },
              [
                _c("font-awesome-icon", {
                  staticClass: "mr-1 status-icon",
                  attrs: { icon: ["fas", "file"] },
                }),
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "layers-element-title grow-1" },
              [
                _c(_setup.EditableText, {
                  attrs: {
                    value: _vm.item.element.name,
                    "default-text": _vm.item.element.name,
                    "allow-editing": _setup.flags?.enableEditTitlePageEps,
                  },
                  on: { input: _setup.onElementTitleChange },
                }),
              ],
              1
            ),
          ]),
        ]),
      ])
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }